import { buildSchema } from "@camberi/firecms";

export const feedbackQuestionsSchema = buildSchema({
    name: "Feedback Questions",
    properties: {
        question: {
            title: "Question",
            dataType: "string",
            validation: { required: true },
        },
        category: {
            title: "Category",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    unsubscribedUser: "Unsubscribed User Feedback",
                    general: "General Feedback"
                }
            }
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        published: {
            title: "Published",
            dataType: "boolean",
            validation: { required: true },
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            columnWidth: 400,
            validation: { required: true },
        },
    },
    defaultValues: {
        category: "unsubscribedUser"
    }

});

export const feedbackAnswerSchema = buildSchema({
    name: "Feedback Answer",
    properties: {
        answer: {
            title: "Answer",
            dataType: "string",
            validation: { required: true },
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp"
        },
    },
    defaultValues: {
        status: false
    }
});